import { APIValidationError } from '../../types/api/api';
import { Assessoria } from '../../types/assessories/assessoria.d';
import { LinksPage, PageInfo } from '../../types/pagination/pagination';
import { ISO8601DateString, UUID } from '../../types/standard';
import toQueryParams from '../../utils/toQueryParams';
import { Result, validatedApiCall } from '../api';

export interface GetAssessoriesDTO extends AssessoriesFilters {
  page: number;
  size: number;
}

export interface AssessoriesDTO {
  data: Assessoria[];
  links: LinksPage;
  meta: PageInfo;
}

export interface AssessoriesFilters {
  oficina_id?: UUID;
  tipus?: string;
  from: ISO8601DateString;
  to: ISO8601DateString;
}

export const getAssessories = async (
  data: GetAssessoriesDTO,
): Promise<Result<AssessoriesDTO, APIValidationError>> => {
  return validatedApiCall<AssessoriesDTO>(
    `/api/assessories?${toQueryParams(
      data as unknown as Record<string, string>,
    )}`,
    {
      method: 'GET',
      auth: true,
    },
  );
};
